<app-admin-header 
  [header]="'Product Types' | translator" 
  [links]="links" 
  [breadcrumbs]="breadcrumbs" 
  [stats]="[
    { name: translate('Active'), number: getActiveCount(), icon: 'pi pi-check-circle' },
    { name: translate('Inactive'), number: getInactiveCount(), icon: 'pi pi-times-circle' }
  ]">
</app-admin-header>

<div class="container-fluid p-4">
  <div class="btn-section mb-4">
    <div class="d-flex justify-content-between align-items-center">
      <div class="search-container">
        <span class="p-input-icon-right w-100">
          <i class="pi pi-search"></i>
          <input 
            type="text" 
            pInputText 
            [(ngModel)]="searchText" 
            (input)="onSearchChange()"
            [placeholder]="'Search product types...' | translator"
            class="search-input" />
        </span>
      </div>
      <div>
        <button 
          *ngIf="permissionService.hasPermission('PRODUCT_TYPE', 'c')" 
          class="v4-btn-every align-items-center d-flex" 
          (click)="openAddForm()">
          <i class="pi pi-plus-circle mx-2"></i>
          {{ "Add Product Type" | translator }}
        </button>
      </div>
    </div>
  </div>

  <!-- Loading Spinner -->
  <div class="d-flex justify-content-center" *ngIf="spinner">
    <p-progressSpinner 
      [hidden]="!spinner" 
      styleClass="w-4rem h-4rem pb-4" 
      strokeWidth="8"
      fill="var(--surface-ground)" 
      animationDuration=".5s">
    </p-progressSpinner>
  </div>

  <!-- Product Types Grid -->
  <div class="product-types-grid" *ngIf="!spinner && filteredTypes.length > 0">
    <div class="product-type-card" *ngFor="let type of filteredTypes">
      <div class="card-header">
        <div class="type-letter-badge">
          {{ type.letter }}
        </div>
        <div class="type-status-badge" [class.active]="type.active" [class.inactive]="!type.active">
          <i [class]="type.active ? 'pi pi-check-circle' : 'pi pi-times-circle'"></i>
          <span>{{ type.active ? (translate('Active') | translator) : (translate('Inactive') | translator) }}</span>
        </div>
      </div>
      
      <div class="card-body">
        <h3 class="type-name">{{ type.name }}</h3>
        <div class="type-info">
          <div class="info-item">
            <i class="pi pi-tag"></i>
            <span class="label">{{ translate('Letter') }}:</span>
            <span class="value">{{ type.letter }}</span>
          </div>
        </div>
      </div>

      <div class="card-actions">
        <button 
          *ngIf="permissionService.hasPermission('PRODUCT_TYPE', 'u')"
          class="action-btn edit-btn" 
          (click)="openEditForm(type)"
          [title]="translate('Edit')">
          <i class="pi pi-pencil"></i>
          <span>{{ translate('Edit') }}</span>
        </button>
        <button 
          *ngIf="permissionService.hasPermission('PRODUCT_TYPE', 'd')"
          class="action-btn delete-btn" 
          (click)="deleteType(type)"
          [title]="translate('Delete')">
          <i class="pi pi-trash"></i>
          <span>{{ translate('Delete') }}</span>
        </button>
      </div>
    </div>
  </div>

  <!-- No Data Message -->
  <div class="d-flex justify-content-center" *ngIf="!spinner && filteredTypes.length === 0">
    <app-no-data></app-no-data>
  </div>
</div>

<!-- Add/Edit Form Dialog -->
<p-dialog 
  [(visible)]="showAddForm" 
  [modal]="true" 
  [closable]="true" 
  [draggable]="false" 
  [resizable]="false"
  [style]="{width: '95vw', maxWidth: '600px'}"
  [header]="(isEditMode ? ('Edit Product Type' | translator) : ('Add Product Type' | translator))"
  (onHide)="closeForm()">
  
  <div class="form-container" *ngIf="showAddForm">
    <form (ngSubmit)="onSubmit()">
      <div class="form-group">
        <label for="name" class="form-label">
          {{ translate('Name') }} <span class="required">*</span>
        </label>
        <input 
          type="text" 
          id="name"
          pInputText 
          [(ngModel)]="formData.name" 
          name="name"
          [placeholder]="translate('Enter product type name')"
          class="form-input"
          required />
      </div>

      <div class="form-group">
        <label for="letter" class="form-label">
          {{ translate('Letter') }} <span class="required">*</span>
        </label>
        <input 
          type="text" 
          id="letter"
          pInputText 
          [(ngModel)]="formData.letter" 
          name="letter"
          [placeholder]="translate('Enter single letter')"
          class="form-input"
          maxlength="1"
          required />
        <small class="form-hint">{{ translate('Enter a single letter (e.g., A, B, C)') }}</small>
      </div>

      <div class="form-group">
        <label for="active" class="form-label">
          {{ translate('Status') }}
        </label>
        <p-selectButton class="v4-selectbutton"
          [options]="[
            { label: translate('Active'), value: true, icon: 'pi pi-check-circle' },
            { label: translate('Inactive'), value: false, icon: 'pi pi-times-circle' }
          ]"
          [(ngModel)]="formData.active"
          name="active"
          optionLabel="label"
          optionValue="value">
        </p-selectButton>
      </div>

      <div class="form-actions">
        <button 
          type="button" 
          class="btn btn-secondary" 
          (click)="closeForm()">
          <i class="pi pi-times mx-2"></i>
          {{ translate('Cancel') }}
        </button>
        <button 
          type="submit" 
          class="btn btn-primary"
          [disabled]="spinner">
          <i class="pi pi-check mx-2"></i>
          {{ isEditMode ? translate('Update') : translate('Create') }}
        </button>
      </div>
    </form>
  </div>
</p-dialog>

<p-confirmDialog></p-confirmDialog>
<p-toast></p-toast>
<app-footer></app-footer>

